import { ExpedientFormData } from '@/containers/logistic/expedients/wizzardExpedient/ExpedientWizard'
import query from './APIServicesV2'

interface Media {
  params: {
    documentType: string
    size: number
    ext: string
    isPrivate: boolean
    name: string
  }
  file: File
}

export const postMedia = async (media: Media) => {
  const response = await query.post('/media', media.params)
  const img = await fetch(response.data.url, {
    method: 'PUT',
    body: media.file,
    headers: {
      'Content-type': media.file.type,
    },
  })
  return response.data.key
}

export const postMediaUrl = async (params: {
  key: string
  isPrivate: string
}) => {
  const response = await query.post('/media/url', params)

  return response?.data?.url
}
